import script from "./AddWorksCVUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AddWorksCVUpload.vue?vue&type=script&setup=true&lang=js"

import "./AddWorksCVUpload.vue?vue&type=style&index=0&id=0ac810f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac810f6"]])

export default __exports__